import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AtomModule } from '../../atom/atom.module'
import { environment } from '../../environments/environment'
import { AppService } from '../../service/app.service'

@Component({
  selector: 'app-google-signin',
  templateUrl: './google-signin.component.html',
  styleUrl: './google-signin.component.less',
  standalone: true,
  imports: [AtomModule],
})
export class GoogleSigninComponent implements OnInit {
  @Output() registerClick: EventEmitter<void> = new EventEmitter()
  @Output() token: EventEmitter<string> = new EventEmitter()
  @Output() buttonClick: EventEmitter<void> = new EventEmitter()

  @Input() pluginName = ''
  @Input() text = ''

  isBrowser: boolean

  constructor(public appService: AppService) {}

  ngOnInit(): void {
    this.appService.isBrowser$.subscribe((state) => {
      this.isBrowser = state
    })
  }

  login = () => {
    this.buttonClick.emit()
    const googleLoginWrapper = document.createElement('div')
    googleLoginWrapper.style.display = 'none'
    googleLoginWrapper.classList.add('custom-google-button')
    document.body.appendChild(googleLoginWrapper)
    window['google'].accounts.id.initialize({
      client_id: environment.GOOGLE_CLIENT_ID,
      callback: (response) => {
        this.token.emit(response.credential)
      },
    })
    window['google'].accounts.id.renderButton(googleLoginWrapper, {
      theme: 'outline',
      size: 'large',
    })

    const googleLoginWrapperButton = googleLoginWrapper.querySelector(
      'div[role=button]'
    ) as HTMLElement

    googleLoginWrapperButton?.click()
  }
}
